const config = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DATABASEURL,
  projectId: process.env.REACT_APP_PROJECTURL,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_ID
};

export const khaltiConfiguration = {
  publicKey: process.env.REACT_APP_KHALTIPUBLICKEY,
  productURL: process.env.REACT_APP_KHALTIPRODUCTURL
};

export default config;
